export const replaceParams = (
  route: string,
  params: Record<string, string | number>,
): string => {
  return Object.entries(params).reduce((updatedRoute, [key, value]) => {
    return updatedRoute.replace(new RegExp(`:${key}`, 'g'), value.toString());
  }, route);
};

const learnerPortal = {
  get() {
    return '/learner-portal';
  },
  get overview() {
    return `${this.get()}/overview`;
  },
  get courses() {
    return `${this.get()}/courses`;
  },
  get skillsProgrammes() {
    return `${this.get()}/skills-programmes`;
  },
  get qualifications() {
    return `${this.get()}/qualifications`;
  },
  get certificates() {
    return `${this.get()}/certificates`;
  },
  get viewCourse() {
    return `${this.get()}/course/:courseId`;
  },
} as const;

const managerPortal = {
  get() {
    return '/manager-portal';
  },
  get overview() {
    return `${this.get()}/overview`;
  },
  get courses() {
    return `${this.get()}/courses`;
  },
  get viewCourse() {
    return `${this.get()}/course/:courseId`;
  },
  get skillsProgrammes() {
    return `${this.get()}/skills-programmes`;
  },
  get qualifications() {
    return `${this.get()}/qualifications`;
  },
  get certificates() {
    return `${this.get()}/certificates`;
  },
  get scheduler() {
    return `${this.get()}/scheduler`;
  },
  get learnerEnrollments() {
    return `${this.get()}/learner-enrollments`;
  },
  get userOverview() {
    return `${this.get()}/user-overview`;
  },
  get users() {
    return `${this.get()}/users`;
  },
  get userDetail() {
    return `${this.get()}/users/:userId`;
  },
  get enrollments() {
    return `${this.get()}/enrollments`;
  },
  get cohorts() {
    return `${this.get()}/cohorts`;
  },
  get cohortDetail() {
    return `${this.get()}/cohorts/:cohortId`;
  },
  get courseModules() {
    return `${this.get()}/modules`;
  },
  get moduleManagement() {
    return `${this.get()}/module-management`;
  },
  get announcements() {
    return `${this.get()}/announcements`;
  },
} as const;

const adminPortal = {
  get() {
    return '/admin-portal';
  },
  get scorm() {
    return `${this.get()}/scorm`;
  },
  get scormTemplates() {
    return `${this.get()}/scorm-templates`;
  },
  get courses() {
    return `${this.get()}/courses`;
  },
  get skillsProgrammes() {
    return `${this.get()}/skills-programmes`;
  },
  get skillsProgrammeTemplates() {
    return `${this.get()}/skills-programme-templates`;
  },
  get qualifications() {
    return `${this.get()}/qualifications`;
  },
  get qualificationTemplates() {
    return `${this.get()}/qualification-templates`;
  },
  get users() {
    return `${this.get()}/users`;
  },
  get userDetail() {
    return `${this.get()}/users/:userId`;
  },
  get enrollments() {
    return `${this.get()}/enrollments`;
  },
  get createEnrollments() {
    return `${this.get()}/create-enrollments`;
  },
  get certificates() {
    return `${this.get()}/certificates`;
  },
  get cohorts() {
    return `${this.get()}/cohorts`;
  },
  get cohortDetail() {
    return `${this.get()}/cohorts/:cohortId`;
  },
  get assessments() {
    return `${this.get()}/assessments`;
  },
  get assessmentCreate() {
    return `${this.get()}/assessments/create`;
  },
  get assessmentEdit() {
    return `${this.get()}/assessments/edit/:assessmentId`;
  },
  get assessmentTemplates() {
    return `${this.get()}/assessment-templates`;
  },
  get assessmentTemplateCreate() {
    return `${this.get()}/assessment-templates/create`;
  },
  get assessmentTemplateDetail() {
    return `${this.get()}/assessment-templates/:templateId`;
  },
  get assessmentTemplateEdit() {
    return `${this.get()}/assessment-templates/:templateId/edit`;
  },
  get courseModules() {
    return `${this.get()}/modules`;
  },
  get moduleManagement() {
    return `${this.get()}/module-management`;
  },
  get standUpTasks() {
    return `${this.get()}/standup-tasks`;
  },
} as const;

export const routes = {
  get notFound() {
    return '*';
  },
  get landing() {
    return '/';
  },
  get authRedirect() {
    return '/auth/redirect';
  },
  get login() {
    return '/login';
  },
  get users() {
    return '/users';
  },
  get reports() {
    return '/reports';
  },
  get profile() {
    return '/profile';
  },
  get unauthorised() {
    return '/unauthorised';
  },
  managerPortal,
  learnerPortal,
  adminPortal,
} as const;
